<template>
	<AppPage>
		<AppPageHeader
			title="Offerteaanvragen"
			description="Overzicht van alle aanvragen in dit dossier"
		>
			<template #buttons>
				<AppButton variant="primary" @click="openCreateModal">
					+ Maak nieuwe aanvraag
				</AppButton>
			</template>
		</AppPageHeader>

		<div class="p-8 max-w-[1000px] w-full mx-auto">
			<LoanApplicationList
				v-if="dossierStore.selectedDossier"
				:dossier="dossierStore.selectedDossier"
			/>
			<LoanApplicationCreateModal v-model="isCreateModalOpen" />
		</div>
	</AppPage>
</template>

<script setup lang="ts">
import { useDossierStore } from "@/store/useDossierStore";
import { ref } from "vue";

const isCreateModalOpen = ref(false);
const openCreateModal = () => (isCreateModalOpen.value = true);
const dossierStore = useDossierStore();
</script>
